<template>
	<div class="sunset-points" v-if="shouldShowApplySunsetPointsBtn">
		{{ $t("utilityComponents.sunsetPointsInput.youHave0Points", { points: unusedPoints, crowns: sunsetPointsCountCurrencyValue }) }}
		<a class="check-points" @click="removePoints" v-if="!isOverLimit && hasAppliedSunsetPoints && !isSubscribed">
			{{ $t("utilityComponents.sunsetPointsInput.removePoints", { points: appliedSunsetPoints }) }}
		</a>
		<a class="check-points" @click="applyPoints" v-if="!isOverLimit && !hasAppliedSunsetPoints && !isSubscribed">
			{{ $t("utilityComponents.sunsetPointsInput.applyPoints") }}
		</a>
	</div>
</template>
<script>
	import { mapGetters } from "vuex";
	import { SET_SUNSET_POINTS } from "../../store/mutation-types";
	import { formatPrice } from "../../domains2/libraries/Utils";
	import appConfig from "../../appconfig";
	import {Adjust, AdjustEvent} from "@awesome-cordova-plugins/adjust";
	import {ADJUST_SDK_EVENT_KEYS} from "../../libraries/globalTemplateSpecific/bm100/utils";
	import {shouldRuleBeAppliedToShop} from "../../domains2/priceRules/priceRulesHelpers";

	export default {
		name: "SunsetPointsInput",
		mounted() {
			if(this.shouldShowApplySunsetPointsBtn && this.isOverLimit) {
				this.applyPoints();
			}
		},
		computed: {
			...mapGetters([ "customerDetails", "sunsetPoints", "sunsetPointsCount", "appliedSunsetPoints", "globalSelectedShop", "priceRules", "isSubscribed" ]),
			hasAppliedSunsetPoints() {
				return this.sunsetPoints !== null;
			},
			isOverLimit() {
				return this.sunsetPointsCount >= this.maxAllowedPoints;
			},
			maxAllowedPoints() {
				return Math.round(this.sunsetPointsPriceRuleOptions.discountMax / this.sunsetPointsPriceRuleOptions.pointsCoefficient);
			},
			shouldShowApplySunsetPointsBtn() {
				return this.sunsetPointsCount > 0 && this.sunsetPointsPriceRule;
			},
			sunsetPointsPriceRule() {
				const pointsRule = (this.priceRules || [])
					.find(rule => (rule.options || {}).label === "SunsetPoints");
				if(pointsRule) {
					const isAvailableForShop = shouldRuleBeAppliedToShop(pointsRule.shopPattern, this.globalSelectedShop.id);
					if(isAvailableForShop) {
						return pointsRule;
					}
				}
			},
			sunsetPointsPriceRuleOptions() {
				return (this.sunsetPointsPriceRule || {}).options || {};
			},
			sunsetPointsCountCurrencyValue () {
				return formatPrice(this.unusedPoints * this.sunsetPointsPriceRuleOptions.pointsCoefficient);
			},
			unusedPoints() {
				return this.sunsetPointsCount - (this.appliedSunsetPoints || 0);
			}
		},
		methods: {
			applyPoints() {
				this.$store.commit(SET_SUNSET_POINTS, {
					customerId: this.customerDetails.customerId,
					totalPoints: this.sunsetPointsCount
				});
				if(appConfig.mobile.isMobileApp()) {
					Adjust.trackEvent(new AdjustEvent(ADJUST_SDK_EVENT_KEYS.POINTS_SPENT));
				}
			},
			removePoints() {
				this.$store.commit(SET_SUNSET_POINTS, null);
			}
		}
	};
</script>
<style lang="scss" scoped>
.sunset-points {
	background-color: #ffd800;
	padding: 10px 16px;
	border-radius: 5px;
	display: flex;
	justify-content: space-between;
	.check-points {
		color: #000000;
		text-decoration: underline;
		font-weight: bold;
	}
}
</style>
